import { render, staticRenderFns } from "./onebox-login.vue?vue&type=template&id=bde70aa2&"
import script from "./onebox-login.vue?vue&type=script&lang=js&"
export * from "./onebox-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports